import {FolderOpen} from '@nlabs/gothamjs/icons';

import {marketingAssets} from '../../content/marketingAssets.js';

import type {ReactElement} from 'react';

const projects = [
  {image: marketingAssets.space, name: 'Short film'},
  {image: marketingAssets.campaign, name: 'Product campaign'},
  {image: marketingAssets.coast, name: 'Travel series'}
];

export const ActiveProjectsVisual = (): ReactElement => (
  <>
    <div className="mb-3 flex items-center justify-between text-[9px] leading-3.5 tracking-[.14em] text-white/55">
      <span>YOUR WORKSPACE</span>
      <span className="flex items-center gap-1.5 tracking-normal text-sky-200"><span className="size-1.5 rounded-full bg-sky-300" />3 active projects</span>
    </div>
    <ul className="space-y-2">
      {projects.map(({image, name}) => (
        <li className="flex h-14 items-center gap-2.5 rounded-xl border border-violet-300/20 bg-white/4 px-2 py-1.5" key={name}>
          <img alt="" className="size-10 shrink-0 rounded-lg object-cover" loading="lazy" src={image} />
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-1.5 text-[11px] leading-3.5 font-medium text-violet-100"><FolderOpen className="shrink-0 text-violet-300" size={12} /><span>{name}</span></div>
            <div className="mt-1 flex gap-1.5 text-[8px] leading-3 text-white/65">
              {['Brief', 'Cast', 'Shots'].map((label) => <span className="rounded-sm bg-violet-300/10 px-1.5 py-0.5" key={label}>{label}</span>)}
            </div>
          </div>
        </li>
      ))}
    </ul>
  </>
);
